// eslint-disable-next-line no-unused-vars
import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const AboutPage = ({ id }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id={id}
      className="h-full py-10  lg:py-0 lg:h-screen bg-gray-100 flex flex-col justify-center gap-10 "
    >
      <div className="flex flex-col w-7/8 md:w-3/4 self-center gap-4">
        <p className="text-gray-800 text-2xl md:text-4xl font-semibold w-7/8 self-center md:self-end text-wrap">
          Innovation That Transforms
        </p>
        <p
          className="text-gray-600 text-xs xs:text-lg
        lg:text-base w-7/8 self-center md:self-end text-wrap"
        >
          We drive change through innovation by developing transformative ideas,
          making strategic investments, and launching groundbreaking products.
          Our strength lies in merging investment with technological creativity
          to create scalable and sustainable solutions. By anticipating trends
          and integrating cutting-edge technology, we generate long-term value,
          empower businesses, and open new opportunities in a constantly
          evolving world.
        </p>
      </div>
      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 200 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 200 }}
        transition={{ duration: 0.8, ease: "linear" }}
        className="w-7/8 md:w-3/4 flex self-center"
      >
        <img
          src="/about-img1.webp"
          alt="About image 1"
          className="h-40 xs:h-50 md:h-80 w-full object-cover rounded-2xl"
        />
      </motion.div>
    </section>
  );
};

export default AboutPage;
